export default "__VITE_ASSET__CUuLLIty__"